export interface MotivoRestituicaoOption {
  value: string;
  label: string;
}

export interface DocumentoAnexoOption {
  id: string;
  label: string;
}

export const MOTIVOS_RESTITUICAO_PADRAO: MotivoRestituicaoOption[] = [
  { value: 'NAO_REALIZACAO_ATO', label: 'a não realização do ato notarial ou de registro' },
  { value: 'DUPLICIDADE', label: 'o recolhimento em duplicidade' },
  { value: 'INDEVIDO', label: 'o recolhimento indevido' },
  { value: 'MAIOR', label: 'o recolhimento efetuado a maior' }
];
export const DOCUMENTOS_ANEXOS_PADRAO: DocumentoAnexoOption[] = [
  { id: 'docIdentidadeLegitimado', label: 'Documentos de identidade - Legitimado*' },
  { id: 'cnpjServentia', label: 'Documento de CNPJ da serventia*' },
  { id: 'cdtCpfResponsavel', label: 'Certidão de Débitos Tributários - CPF responsável pela serventia*' },
  { id: 'cdtCnpjServentia', label: 'Certidão de Débitos Tributários - CNPJ da serventia*' },
  { id: 'guiaBoletoEComprovante', label: 'Guia/Boleto e Comprovante de pagamento do Documento/Boleto*' },
  { id: 'declaracaoDapDfJ', label: 'Declaração de Apuração de Taxa de Fiscalização Judiciária - DAP/TFJ*' },
  { id: 'procuracao', label: 'Procuração' },
  { id: 'comprovanteRessarcimento', label: 'Comprovante de ressarcimento valor cobrado a título de emolumentos e de TFJ' },
  { id: 'demonstrativoAtos', label: 'Demonstrativo de cada um dos atos com os valores recolhidos por meio do DAE' }
];
